import { useParams } from 'react-router-dom';
import { useRequest } from '../../../../lib/hooks';
import { request } from '../../../../lib/utils/request';
import { BookDto } from '../dto/BookDto';
import { InsertBookDto } from '../dto/InsertBookDto';
import { UpdateBookDto } from '../dto/UpdateBookDto';
import { extract_num_id_from_id } from '../utils/extract_num_id_from_id';

const BASE_URL = `${process.env.REACT_APP_BOOKS_API}/books`;

export function useBooksApi() {
	const { id } = useParams() as { id: string };

	const num_id = extract_num_id_from_id(id);

	const insert = useCreateBook();
	const remove = useRemoveBook();
	const update = useUpdateBook(num_id);
	const get_last_id = useGetLastBookID();

	return {
		insert,
		remove,
		update,
		get_last_id,
	};
}

function useCreateBook() {
	const [result, loading, error, do_create] = useRequest<BookDto>(
		(dto: InsertBookDto) =>
			new Promise((resolve, reject) => {
				request()
					.post(BASE_URL, dto)
					.then((res) => setTimeout(() => resolve(res as BookDto), 1500))
					.catch(reject);
			})
	);

	return {
		create: (dto: InsertBookDto) => do_create(dto),
		result,
		error,
		loading,
	};
}

function useUpdateBook(num_id: string) {
	const [result, loading, error, update] = useRequest<BookDto>(
		(dto: UpdateBookDto) =>
			new Promise((resolve, reject) => {
				request()
					.put(`${BASE_URL}/${num_id}`, dto)
					.then((res) => setTimeout(() => resolve(res as BookDto), 1500))
					.catch(reject);
			})
	);

	return {
		do_update: (dto: UpdateBookDto) => update(dto),
		result,
		error,
		loading,
	};
}

function useRemoveBook() {
	const [result, loading, error, remove] = useRequest<string>(
		(num_id: string) =>
			new Promise((resolve, reject) => {
				request()
					.delete(`${BASE_URL}/${num_id}`)
					.then((res) => setTimeout(() => resolve(res as string), 1500))
					.catch(reject);
			})
	);

	return {
		do_remove: (num_id: string) => remove(num_id),
		result,
		loading,
		error,
	};
}

function useGetLastBookID() {
	const [result, loading, error, do_get] = useRequest<{ num_id: string }>(
		() =>
			new Promise((resolve, reject) => {
				request()
					.get(`${BASE_URL}/last-id`)
					.then((res) => setTimeout(() => resolve(res as { num_id: string }), 1500))
					.catch(reject);
			})
	);

	return {
		get: () => do_get(),
		result,
		error,
		loading,
	};
}
